import { useEffect } from "react";
import { siteConfig } from "@/lib/site-config";
import { useHasInteracted } from "@/hooks/use-interaction";

/**
 * Loads the LeadConnector chat widget on the visitor's first interaction.
 *
 * The loader pulls in a large third-party bundle and sets cookies, so keeping
 * it out of the initial page load protects Core Web Vitals and best-practices
 * scores. A real visitor triggers it within moments; the chat bubble then
 * appears exactly as before.
 */
const ChatWidget = () => {
  const ready = useHasInteracted();

  useEffect(() => {
    if (!ready) return;
    const { chatWidgetId, chatLoaderSrc, chatResourcesUrl } = siteConfig.widgets;
    if (!chatWidgetId) return;
    if (document.getElementById("lc-chat-widget-loader")) return;

    const s = document.createElement("script");
    s.id = "lc-chat-widget-loader";
    s.src = chatLoaderSrc;
    s.setAttribute("data-resources-url", chatResourcesUrl);
    s.setAttribute("data-widget-id", chatWidgetId);
    s.async = true;
    document.body.appendChild(s);
  }, [ready]);

  return null;
};

export default ChatWidget;
